import React, { useRef, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

const Tooltip = ({ children, text, visible = false }) => {
  const triggerRef = useRef(null);
  const [position, setPosition] = useState({ top: 0, left: 0 });

  useEffect(() => {
    if (visible && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      setPosition({
        top: rect.top + rect.height / 2,
        left: rect.right + 8
      });
    }
  }, [visible]);

  return (
    <>
      <div ref={triggerRef}>
        {children}
      </div>
      {visible && createPortal(
        <div 
          className="fixed z-[9999] w-48"
          style={{
            top: `${position.top}px`,
            left: `${position.left}px`,
            transform: 'translateY(-50%)'
          }}
        >
          <div className="bg-gray-900 text-white text-xs rounded-lg px-3 py-2 shadow-lg">
            {text}
            <div className="absolute right-full top-1/2 -translate-y-1/2 border-4 border-transparent border-r-gray-900"></div>
          </div>
        </div>,
        document.body
      )}
    </>
  );
};

export default Tooltip;
